export default {
  // <input style="margin: 4px 0 4px 0;" type="text" v-model="filterText" v-on:keyup="updateFilter($event)" placeholder="Full name search..."/>
  template: `
      <div class="custom-filter" style="padding-top: 3px; width: 200px; height: 200px;" :id="filterId">
        <b-tabs type="is-boxed" size="is-small" expanded>
          <b-tab-item label="Text" icon="format-text">
          </b-tab-item>
          <b-tab-item label="Toggle" icon="filter-outline">
            <b-dropdown
              v-model="filterSelected"
              multiple
              inline
              aria-role="list"
              @change="updateFilter($event)"
            >
              <hr style="margi  n: 0.5rem 0;">
              <b-dropdown-item
                v-for="(option, idx) in filterArray"
                :value="option"
                :key="'param'+option+idx"
                aria-role="listitem"
              >
                <span>{{ option }}</span>
              </b-dropdown-item>
          </b-dropdown>
        </b-tab-item>
      </b-tabs>
    </div>
    `,
  // <b-dropdown-item
  //   value="ALLCHECK"
  //   aria-role="listitem"
  //   @click="selectAll()"
  // >
  //   <span>SELECT ALL</span>
  // </b-dropdown-item>
  data () {
    return {
      filterId: null,
      filterText: null,
      filterSelected: [],
      // filterSelectedArray: [],
      filterArray: []
    }
  },
  created () {
    this.filterId = this.params.colDef.field
    console.log('this.filterId', this.filterId)
  },
  mounted () {
    console.log('mounted', this.params)
    console.log('mounted', this.params.api.getModel())
    let { rowsToDisplay } = this.params.api.getModel()
    console.log(this.rowsToDisplay)
    let colId = this.params.colDef.field
    let filterArr = []
    rowsToDisplay.forEach((row) => {
      console.log(row.data[colId])
      if (!filterArr.includes(row.data[colId])) {
        filterArr.push(row.data[colId])
      }
    })
    this.filterArray = _.clone(filterArr)
    this.filterSelected = _.clone(filterArr)
    // this.filterSelected = ['ALLCHECK'].concat(filterArr)
    console.log(this.filterArray)
  },
  watch: {
    filterSelected (selectedOptions) {
      console.log('selected watch', this.filterArray)
      // let filterOtions = selectedOptions.filter(option => option !== 'ALLCHECK')
      // if (filterOtions.length === this.filterArray.length &&
      //   !selectedOptions.includes('ALLCHECK')) {
      //   this.filterSelected.unshift('ALLCHECK')
      // } else if (filterOtions.length < this.filterArray.length &&
      //   selectedOptions.includes('ALLCHECK')) {
      //   this.filterSelected.shift()
      // }
    }
  },
  methods: {
    updateFilter () {
      console.log('updateFilter', this.params)
      this.params.filterChangedCallback()
    },

    doesFilterPass (params) {
      console.log('doesFilterPass', this.params)
      // make sure each word passes separately, ie search for firstname, lastname
      let passed = true
      // this.filterText
      //   .toLowerCase()
      //   .split(' ')
      //   .forEach((filterWord) => {
      //     const value = this.params.valueGetter(params)

      //     if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
      //       passed = false
      //     }
      //   })
      const value = this.params.valueGetter(params)
      console.log('doesFilterPass filter value', value)
      console.log('!this.filterSelected.includes(value.toString())', !this.filterSelected.includes(value.toString()))
      console.log(this.filterSelected)
      // if (!this.filterSelected.includes(value.toString())) {
      if (!this.filterSelected.includes('ALLCHECK') && this.filterSelected.indexOf(value.toString()) < 0) {
        passed = false
      }

      return passed
    },

    isFilterActive () {
      console.log('isFilterActive', this.params)
      return !(this.filterSelected.length < 0)
      // return this.filterSelected !== null && this.filterSelected !== ''
    },

    getModel () {
      console.log('getModel', this.params)
      return {
        // value: this.filterText,
        value: this.filterSelected
        // dropdownFilter: this.filterSelectedArray
      }
    },

    setModel (model) {
      console.log('setModel', this.params)
      // this.filterText = model.value
      this.filterSelected = model.value
    },

    selectAll () {
      if (this.filterSelected.includes('ALLCHECK')) {
        let optionList = ['ALLCHECK']
        optionList.push(...this.filterArray)
        console.log('select all', optionList)
        this.filterSelected = optionList
      } else {
        this.filterSelected = []
      }
    }
  }
}
